// src/providers/MessageProvider.jsx
import React, { createContext, useContext } from "react";
import { message } from "antd";
import PropTypes from "prop-types";


const MessageContext = createContext(null);

export const MessageProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <MessageContext.Provider value={messageApi}>
      {contextHolder} {/* message container, only rendered once */}
      {children}
    </MessageContext.Provider>
  );
};
MessageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useMessageApi = () => {
  const ctx = useContext(MessageContext);
  if (!ctx) {
    throw new Error("useMessageApi must be used inside MessageProvider");
  }
  return ctx;
};
